export default __webpack_public_path__ + "static/media/errImage.49bf57c4.png";